
  document.addEventListener('DOMContentLoaded', function () {
    const observer = new MutationObserver(function () {
      // Only restore if Gorgias chat is open
      const gorgiasOpen = document.querySelector('iframe[id*="gorgias"], .gorgias-chat-open, [data-gorgias-open]');
      if (gorgiasOpen) {
        document.querySelectorAll('[data-focus-on-hidden]').forEach(function (el) {
          el.removeAttribute('aria-hidden');
        });
      }
    });

    observer.observe(document.body, {
      attributes: true,
      subtree: true,
      attributeFilter: ['aria-hidden']
    });
  });
